import styled from 'styled-components';
import { color, units, borderRadius, boxShadow, typeStyle } from '@m/alchemy-ui/theme';

const AlchemyDisplayBox = styled.div`
  background-color: ${color('container')};
  padding: ${units(2)};
  border-radius: ${borderRadius('extraExtraLarge')};
  box-shadow: ${boxShadow('moduleChrome')};
  ${typeStyle('base')};
`;

export default AlchemyDisplayBox;
